import { useEffect, useState } from "react";

const HeaderDark = ({ extraComponent = null }: { extraComponent?: any }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', handleResize);
	}, []);
	
return (

		<div className='navbar_container'>
		<a href="/" className='navbar_logo-link w-nav-brand' aria-label='home'>
		  <div className='logo-text'
		  >
			<img
			  className='homepage-icon-logo'
			//   src='/assets/output-onlinepngtools-edited.png'
			//   src="/assets/NewLogo-removebg.png"
			src={isMobile ? "/assets/Logo-White.svg" : "/assets/Wordmark+Logo-White.svg"}
			alt='search bubble logo'
			/>
		  </div>
		</a>
	  </div>
	);
};

export default HeaderDark;